import {createApp} from 'vue'

const instances = document.querySelectorAll('.webien-image-gallery');

instances.forEach((instance) => {

    let $app = createApp({
        name: "ImageGallery-" + instance.dataset.unique,
        data() {
            return {
                appReady: false,
                useLog: false,
                settings: JSON.parse(window['imageGallery_' + instance.dataset.unique]),
                images: null,
                activeImage: {
                    url: null,
                    url_large: null,
                    title: null,
                    descr: null,
                    id: null,
                },
                overlayImages: {
                    open: false,
                },

            }
        },
        mixins: [],
        computed: {
            isDev() {
                return window.location.href.indexOf(".test") > -1;
            },

        },
        watch: {},
        methods: {
            log(str) {
                if (this.useLog) console.log(str);
            },
            init() {
                let app = this;

                // Dev
                if (this.isDev) {
                    this.useLog = true;
                }

                this.images = this.settings.images;

                this.activeImage = this.images[0];

                this.log(this.images);

                this.appReady = true;
            },
            updateImage(image) {
                this.activeImage = image;
            },
            openImageOverlay() {
                let app = this;
                this.overlayImages.open = true;

                // Add class to body
                document.body.classList.add('overlay-open');

                document.addEventListener("keydown", (e) => {
                    if (e.key === "Escape") {
                        app.closeImageOverlay();
                    }
                });
            },
            closeImageOverlay() {
                this.overlayImages.open = false;
                document.body.classList.remove('overlay-open');
                document.removeEventListener('keydown', (e) => {});
            },
        },
        mounted: function () {
            this.init();
        },
        created() {
        },
        components: {},
    });


    // Mount app to DOM
    if (document.getElementById("image-gallery-" + instance.dataset.unique)) {
        $app.mount('#image-gallery-' + instance.dataset.unique);
    }


});









